var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66.17 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:#161516;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    y: 43.66,
    width: 66.17,
    height: 7.34
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M10.22,39.2C2.04,39.15-.09,36.83,0,32.22,.14,24.49,.14,16.22,0,8.54-.09,3.8,3.14,0,7.79,0H29.99c4.65,0,7.79,3.8,7.79,8.54v8.8H20.04c.13-2.32,.22-4.74,.22-7.11h-2.83c0,.85,0,1.65-.04,2.41-.04,5.59-.09,8.98,.09,15.02h2.7v-8.13h17.78c-.09,4.02-.09,11.62,0,19.22H20.31v-7.82h-.97c0,6.48-1.02,8.27-8.94,8.27h-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M59.93,11.4c-.04,1.3-.04,2.59-.04,3.89,1.81,0,3.67-.09,5.62-.22v10.64c-1.99-.04-3.8,0-5.62,0,.04,4.33,.13,8.71,.22,13.05h-18.14c.58-12.78,.58-25.52,0-38.3h24.2V11.58c-1.06-.13-3.85-.18-6.24-.18Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMobile);
export default __webpack_public_path__ + "static/media/logoMobile.b7d8009eef1321a8037016033c7fdfe3.svg";
export { ForwardRef as ReactComponent };